'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Datepicker = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactMomentProptypes = require('react-moment-proptypes');

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _dateInput = require('./date-input');

var _dateInput2 = _interopRequireDefault(_dateInput);

var _datepickerSelect = require('./datepicker-select');

var _datepickerSelect2 = _interopRequireDefault(_datepickerSelect);

var _util = require('./util');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * A component for selecting date ranges & types
 */


var Datepicker = exports.Datepicker = function (_React$Component) {
  _inherits(Datepicker, _React$Component);

  function Datepicker() {
    _classCallCheck(this, Datepicker);

    return _possibleConstructorReturn(this, (Datepicker.__proto__ || Object.getPrototypeOf(Datepicker)).apply(this, arguments));
  }

  _createClass(Datepicker, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.initialize) {
        this.props.initialize(this.props.id);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.onUpdate) {
        this.props.onUpdate(nextProps);
      }
    }
  }, {
    key: 'getDisplayString',
    value: function getDisplayString() {
      var selectedPeriod = this.props.selectedPeriod;
      var selectedDate = (0, _momentTimezone2.default)(selectedPeriod.date); // handle week as a special case

      if (selectedPeriod.type === 'week') {
        var weekOf = 'Week of ' + selectedDate.format('MMM D');

        if (this.isToDate()) {
          return weekOf + ' (to date)';
        }

        return weekOf + ', ' + selectedDate.year();
      }

      return '' + (0, _util.fromPeriodToDisplayString)(selectedPeriod) + (this.isToDate() ? ' (to date)' : '');
    }
  }, {
    key: 'isToDate',
    value: function isToDate() {
      var selectedPeriod = this.props.selectedPeriod;

      if (selectedPeriod.type === 'week') {
        return _momentTimezone2.default.range((0, _momentTimezone2.default)(selectedPeriod.date), (0, _momentTimezone2.default)(selectedPeriod.date).endOf('isoWeek')).contains((0, _momentTimezone2.default)());
      }

      var currentDate = (0, _momentTimezone2.default)();
      return (0, _util.isInPeriod)(selectedPeriod, {
        month: currentDate.month(),
        year: currentDate.year()
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          componentClassname = _props.componentClassname,
          inputClassName = _props.inputClassName,
          isOpen = _props.isOpen,
          label = _props.label,
          theme = _props.theme,
          toggleDatepicker = _props.toggleDatepicker,
          openDatepicker = _props.openDatepicker,
          props = _objectWithoutProperties(_props, ['children', 'className', 'componentClassname', 'inputClassName', 'isOpen', 'label', 'theme', 'toggleDatepicker', 'openDatepicker']);

      return _react2.default.createElement('div', {
        className: componentClassname
      }, _react2.default.createElement(_dateInput2.default, {
        className: className,
        theme: theme,
        inputClassName: inputClassName,
        toggleDatepicker: toggleDatepicker,
        openDatepicker: openDatepicker,
        selectedPeriod: props.selectedPeriod,
        label: label,
        id: props.id
      }), isOpen ? _react2.default.createElement(_datepickerSelect2.default, props) : null, children);
    }
  }]);

  return Datepicker;
}(_react2.default.Component);

Datepicker.propTypes = {
  /**
   * Pass a child to render below the date input
   */
  children: _propTypes2.default.node,

  /**
   * Custom classname applied to the base input component
   */
  className: _propTypes2.default.string,

  /**
   * Function to trigger datePicker close
   */
  close: _propTypes2.default.func.isRequired,

  /**
   * Custom classname applied to the root of the datePicker
   */
  componentClassname: _propTypes2.default.string,

  /**
   * Enables/disables selection of year time periods
   */
  enableYearSelection: _propTypes2.default.bool,

  /**
   * Enables dayPicker. Default: false
   */
  enableDayPicker: _propTypes2.default.bool,

  /**
   * Enables last 30 days button. Default: false
   */
  enableLast30Days: _propTypes2.default.bool,

  /**
   * Enables rolling quarters button. Default: false
   */
  enableRollingQuarters: _propTypes2.default.bool,

  /**
   * Specifies end date of datePicker range
   */
  endDate: _reactMomentProptypes2.default.momentObj.isRequired,

  /**
   * Current datePeriod that is being hovered
   */
  hoveringPeriod: _propTypes2.default.shape({
    type: _propTypes2.default.oneOf(_constants2.default.datePickerPeriods),
    date: _propTypes2.default.string
  }).isRequired,

  /**
   * Specific datePicker id
   */
  id: _propTypes2.default.string.isRequired,

  /**
   * Optional callback that fires when component is mounted. Returns component Id
   */
  initialize: _propTypes2.default.func,

  /**
   * Custom classname applied to the input element
   */
  inputClassName: _propTypes2.default.string,

  /**
   * Specifies if datePicker is currently open
   */
  isOpen: _propTypes2.default.bool.isRequired,

  /**
   * Label for input component
   */
  label: _propTypes2.default.string,

  /**
   * Fires when props are updated
   */
  onUpdate: _propTypes2.default.func,

  /**
   * Specify datepicker options
   */
  options: _propTypes2.default.shape({
    t30: _propTypes2.default.bool,
    halfYear: _propTypes2.default.bool
  }),

  /**
   * urrent datePeriod that is selected
   */
  selectedPeriod: _propTypes2.default.shape({
    type: _propTypes2.default.oneOf(_constants2.default.datePickerPeriods),
    date: _propTypes2.default.string
  }).isRequired,

  /**
   * Specifies start date of datePicker range
   */
  startDate: _reactMomentProptypes2.default.momentObj.isRequired,

  /**
   * Sets the color theme to resemble a normal or classic input
   */
  theme: _propTypes2.default.oneOf(['classic', 'normal']),

  /**
   * Function to toggle visibility of datePicker
   */
  toggleDatepicker: _propTypes2.default.func.isRequired,

  /**
   * Function to open datePicker
   */
  openDatepicker: _propTypes2.default.func.isRequired
};
Datepicker.defaultProps = {
  enableDayPicker: false,
  enableLast30Days: false,
  enableRollingQuarters: false,
  enableYearSelection: true
};
exports.default = Datepicker;